var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AppBreadcrumbs',{staticClass:"pb-4",attrs:{"items":_vm.breadItems}}),_c('MasterHeader',{attrs:{"menu":_vm.menu}},[_c('router-view')],1),_c('AppLoadingDialog',{staticStyle:{"z-index":"1000"},attrs:{"loading":_vm.loading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }